/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export const SESSION_MODES = {
  BLANK: 'blank',
  SINGLE: 'single',
  MULTI: 'multi',
  FILTERED_LIST: 'filtered-list',
};

export const DEFAULT_MAX_ATTACHED_ITEMS = 50;

export const COMMAND_CLOUD_AI_SKU_REF = 'command-cloud-ai';

export const COMMAND_INTELLIGENCE_COMPOSER_MAX_HEIGHT_PX = 120;
